import styled from "styled-components";
import { colors } from "../../../components/common/element/elements.js";

export const Styles = styled.div`
  .admin-gallery-page {
    .gallery-area {
      padding: 70px 0;

      .card-box {
        background: #fff;
        border: 1px solid ${colors.border1};
        border-radius: 6px;
        box-shadow: 0 0 25px rgba(0, 0, 0, 0.08);
        padding: 30px;
      }

      .upload-panel {
        border: 2px dashed ${colors.border3};
        border-radius: 6px;
        padding: 25px;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        gap: 15px;
        text-align: center;
        margin-bottom: 30px;

        .preview {
          width: 120px;
          height: 120px;
          border-radius: 6px;
          border: 1px solid ${colors.border3};
          overflow: hidden;
          display: flex;
          align-items: center;
          justify-content: center;
          background: ${colors.bg2};

          img {
            width: 100%;
            height: 100%;
            object-fit: cover;
          }
        }

        .controls {
          display: flex;
          flex-direction: column;
          gap: 10px;
          width: 100%;
          max-width: 320px;

          .form-control-file {
            border: 1px dashed ${colors.border3};
            padding: 12px;
            border-radius: 4px;
            cursor: pointer;
          }
        }

        .btn-upload {
          background: ${colors.red_bg};
          border: none;
          color: #fff;
          text-transform: uppercase;
          font-weight: 600;
          padding: 10px 22px;
          border-radius: 5px;
          &:hover:not(:disabled) {
            background: ${colors.red_bg2};
          }
          &:disabled {
            opacity: 0.6;
            cursor: not-allowed;
            background: ${colors.border3};
            color: ${colors.text3};
          }
        }

        .muted {
          color: ${colors.text3};
          font-size: 13px;
        }
      }

      .data-grid {
        table {
          width: 100%;
          border-collapse: collapse;

          th,
          td {
            padding: 12px 14px;
            border: 1px solid ${colors.border3};
            vertical-align: middle;
            font-size: 14px;
          }

          th {
            background: ${colors.red_bg};
            color: #fff;
            text-transform: uppercase;
            font-weight: 600;
          }

          tbody tr:nth-child(odd) {
            background: #fafafa;
          }

          tbody tr:hover {
            background: rgba(0, 0, 0, 0.03);
          }
        }

        .preview-cell {
          width: 100px;

          img {
            width: 80px;
            height: 80px;
            object-fit: cover;
            border-radius: 4px;
            border: 1px solid ${colors.border3};
          }
        }

        .actions-cell {
          display: flex;
          align-items: center;
          gap: 10px;

          button {
            border: none;
            padding: 6px 12px;
            border-radius: 4px;
            font-size: 13px;
            font-weight: 600;
            text-transform: uppercase;
            cursor: pointer;
          }

          .btn-delete {
            background: ${colors.red};
            color: #fff;

            &:hover {
              background: #e05555;
            }
          }
        }

        .muted {
          color: ${colors.text3};
        }
      }
    }
  }
`;
